import { ROWS, ANIMAL, per100 } from "../jungle/JSchedule";
import { toInput } from "../../lib/irrigation";

export const NAME = { grow: "Grow", "a-bloom": "Bloom A", "b-bloom": "Bloom B", "pk-065": "PK", compact: "Compact", "bongo-bloom": "Bioestimulador" };
export const SUB = { "bongo-bloom": "Bongo Bloom" };
export const FILTERS = [
  ["todos", "Todos", null],
  ["grow", "Grow", ["grow"]],
  ["bloom", "Bloom A/B", ["a-bloom", "b-bloom"]],
  ["pk-065", "PK", ["pk-065"]],
  ["compact", "Compact", ["compact"]],
  ["bongo-bloom", "Bioestimulador", ["bongo-bloom"]],
];
export const IMG = Object.fromEntries(ROWS.map(([id, , img]) => [id, img]));
export const isToday = (d) => toInput(d) === toInput(new Date());
export const dayShort = (d) => d.toLocaleDateString("es-ES", { weekday: "short" }).replace(".", "");
export const ml = (dose) => per100(dose);
export { ANIMAL };
